var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArduino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-1281 -2740)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M43,48H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H43a5.006,5.006,0,0,1,5,5V43A5.006,5.006,0,0,1,43,48ZM24.014,27.342h0c1.55,2.343,4.236,5.261,8.235,5.854a10.27,10.27,0,0,0,1.454.11,9.308,9.308,0,1,0-.027-18.615,8.414,8.414,0,0,0-1.442.11c-2.2.319-5.422,1.592-8.236,5.841C22.447,18.3,19.76,15.381,15.764,14.8a10.354,10.354,0,0,0-1.442-.11,9.308,9.308,0,1,0,0,18.615,8.725,8.725,0,0,0,1.456-.11c2.206-.328,5.425-1.609,8.234-5.854Zm-9.636,2.663h-.069a6.008,6.008,0,1,1,.014-12.011,7.992,7.992,0,0,1,.993.068,7.912,7.912,0,0,1,4.582,2.6A14.993,14.993,0,0,1,22.227,24a15.122,15.122,0,0,1-2.345,3.341,7.936,7.936,0,0,1-4.578,2.6A6.25,6.25,0,0,1,14.378,30.005ZM11.67,23v1.788h5.684V23Zm22.009,7a7.961,7.961,0,0,1-.992-.068,7.928,7.928,0,0,1-4.588-2.6A14.737,14.737,0,0,1,25.776,24,14.753,14.753,0,0,1,28.1,20.664a7.928,7.928,0,0,1,4.588-2.6,7.961,7.961,0,0,1,.992-.068,6.008,6.008,0,1,1,0,12.011ZM30.63,23v1.8h1.919v1.879h1.838V24.806H36.3V23H34.385V21.122H32.547V23Z",
    transform: "translate(1281 2740)",
    fill: "#ffb400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArduino);
export default __webpack_public_path__ + "static/media/Arduino.187f654d1c4ba333d300aa4af32af843.svg";
export { ForwardRef as ReactComponent };